import { render, staticRenderFns } from "./CreateShip.vue?vue&type=template&id=1c990594&scoped=true&"
import script from "./CreateShip.vue?vue&type=script&lang=ts&"
export * from "./CreateShip.vue?vue&type=script&lang=ts&"
import style0 from "./CreateShip.vue?vue&type=style&index=0&id=1c990594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c990594",
  null
  
)

export default component.exports